/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface RestoreBehaviorDataFromDelete$Params {
  patientBehaviorDataID?: number;
}

export function RestoreBehaviorDataFromDelete(http: HttpClient, rootUrl: string, params?: RestoreBehaviorDataFromDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, RestoreBehaviorDataFromDelete.PATH, 'post');
  if (params) {
    rb.query('patientBehaviorDataID', params.patientBehaviorDataID, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

RestoreBehaviorDataFromDelete.PATH = '/api/Staff/RestoreBehaviorDataFromDelete';
